import OGCVectorTileClass, * as OGCVectorTileModule from './../../node_modules/ol/source/OGCVectorTile.js';

class OGCVectorTile extends OGCVectorTileClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in OGCVectorTileModule) {
    if (key !== "default") {
        OGCVectorTile[key] = OGCVectorTileModule[key];
    }
}

export default OGCVectorTile;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/OGCVectorTile.js';